import { Card, Skeleton, theme } from 'antd';
import type { CSSProperties } from 'react';

export type AppPageLoaderVariant = 'page' | 'dashboard' | 'table' | 'detail' | 'cards';

interface AppPageLoaderProps {
  variant?: AppPageLoaderVariant;
}

const SkeletonCard = ({ rows = 2 }: { rows?: number }) => (
  <Card className="app-page-loader__card">
    <Skeleton active paragraph={{ rows }} title={{ width: '42%' }} />
  </Card>
);

export function AppPageLoader({ variant = 'page' }: AppPageLoaderProps) {
  const { token } = theme.useToken();

  return (
    <div
      className={`app-page-loader app-page-loader--${variant}`}
      style={{ '--app-page-loader-bg': token.colorBgContainer } as CSSProperties}
      role="status"
      aria-label="Loading content"
    >
      {variant === 'dashboard' ? (
        <>
          <div className="app-page-loader__metrics">
            {Array.from({ length: 4 }, (_, index) => <SkeletonCard rows={1} key={index} />)}
          </div>
          <div className="app-page-loader__columns"><SkeletonCard rows={5} /><SkeletonCard rows={5} /></div>
        </>
      ) : variant === 'table' ? (
        <>
          <Card className="app-page-loader__toolbar"><Skeleton active paragraph={false} title={{ width: '28%' }} /></Card>
          <SkeletonCard rows={7} />
        </>
      ) : variant === 'detail' ? (
        <>
          <SkeletonCard rows={2} />
          <div className="app-page-loader__columns"><SkeletonCard rows={4} /><SkeletonCard rows={4} /></div>
        </>
      ) : variant === 'cards' ? (
        <div className="app-page-loader__cards">
          {Array.from({ length: 6 }, (_, index) => <SkeletonCard rows={3} key={index} />)}
        </div>
      ) : (
        <><SkeletonCard rows={2} /><SkeletonCard rows={5} /></>
      )}
    </div>
  );
}
